import * as React from "react";
import { Button } from "@material-ui/core";
import CloudDownload from "@material-ui/icons/CloudDownload";
import gql from "graphql-tag";

import { apolloClient } from "app/utils/graphQlClients";
import { User } from "../../userTypes";

const VERIFICATION_IMAGES_ARCHIVE_QUERY = gql`
  query VerificationImagesArchive($external_reference: ID) {
    user(external_reference: $external_reference) {
      external_reference
      verification_images_archive_url
    }
  }
`;

type Props = {
  user: User;
};

type State = {
  loading: boolean;
};

export default class ManualVerificationDownloadAllImagesButton extends React.Component<
  Props,
  State
> {
  state = {
    loading: false,
  };

  downloadAllImages = async () => {
    if (!this.props.user || !this.props.user.external_reference) {
      return;
    }

    this.setState({ loading: true });

    try {
      const result = await apolloClient.query({
        query: VERIFICATION_IMAGES_ARCHIVE_QUERY,
        fetchPolicy: "network-only",
        variables: { external_reference: this.props.user.external_reference },
      });

      const url =
        result && result.data && result.data.user
          ? result.data.user.verification_images_archive_url
          : null;

      if (url) {
        // The archive is presigned with a Content-Disposition of "attachment",
        // so pointing the current window at it starts the download without
        // navigating away from the page. No new tab is needed, which means no
        // blank tab is left behind when the user has no images.
        window.location.href = url;
      } else {
        alert("No verification images are available for this user.");
      }
    } catch (error) {
      alert("Something went wrong while downloading the verification images.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const disabled =
      this.state.loading ||
      !this.props.user ||
      !this.props.user.external_reference;

    return (
      <Button
        color="primary"
        variant="contained"
        className="button no-margin"
        onClick={this.downloadAllImages}
        disabled={disabled}
      >
        {this.state.loading ? "Preparing download..." : "Download All Images"}
        <CloudDownload
          style={{
            marginLeft: "10px",
          }}
        />
      </Button>
    );
  }
}
